import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import swal from "sweetalert";
import { get_Gemstione_User, get_SinglaData_GemstoneOrder } from '../../../store/actions/CommanAction';
import user from './../../../images/task/user.jpg';
import DatePicker from "react-datepicker";
import { editorConfig, getShowingDateText, getShowingMonthDateYear } from '../Utility/Utility';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import 'ckeditor5/ckeditor5.css';
import { ClassicEditor } from 'ckeditor5';

const GemstoneUserAdd = () => {
    const dispatch = useDispatch()
    const SinglaDataGemstoneOrder = useSelector((state) => state.feedBackReducer.SinglaDataGemstoneOrder);
  

    const GemstoneOrderID = useSelector((state) => state.feedBackReducer.GemstoneOrderID);
    const [EditValue, setEditValue] = useState()
    const [IsActive, setIsActive] = useState(true);
    const [CreatedTime, setCreatedTime] = useState();
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [statesChangeStatus, setStatesChangeStatus] = useState(false);
    const [Value, SetValue] = useState({
        Amt: '', UserName: '', OrderNumber: '', IsActive: '1', UserID: '', GemstoneName: '', GSTAmt: '', GemstoneId: '', Address: '', City: '', State: '', PinCode: '', MobileNo: '',
        OrderStatus: '', PaymentStatus: '', TransactionID: '',
    });
    useEffect(() => {
        if (GemstoneOrderID) {
            dispatch(get_SinglaData_GemstoneOrder(GemstoneOrderID));
        }
    }, [GemstoneOrderID]);

    const handleAddFormSubmit = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        if (!error) {
            await AddUpdate('GemstoneOrder/Insert_GemstoneOrder');
            dispatch(get_Gemstione_User(IsActive));


            swal('Good job!', 'Successfully Added', "success"); Reset();
        } else { swal('Oops', errorMsg, "error"); }
    };



    const handleAddFormUpdate = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        const payload = {
            ...Value,
            GemstoneOrderID: GemstoneOrderID,
            ModifiedByUser: '1',
        };
        if (!error) {
            await AddUpdate('GemstoneOrder/Update_GemstoneOrder', payload);
            dispatch(get_Gemstione_User(IsActive));
            swal('Good job!', 'Successfully update', "success");
            Reset();

        } else { swal('Oops', errorMsg, "error"); }
    };




    useEffect(() => {
        setEditValue(SinglaDataGemstoneOrder)
    }, [SinglaDataGemstoneOrder])
    useEffect(() => {
        if (EditValue && EditValue.length > 0) {
            SetValue({
                ...Value,
                'GemstoneOrderID': GemstoneOrderID,
                'Amt': EditValue[0]?.Amt,
                'UserName': EditValue[0]?.UserName,
                'GemstoneName': EditValue[0]?.GemstoneName,
                'OrderNumber': EditValue[0]?.OrderNumber,
                'CreatedTime': EditValue[0].CreatedTime ? getShowingDateText(EditValue[0].CreatedTime) : '',
                'UserID': EditValue[0]?.UserID,
                'GSTAmt': EditValue[0]?.GSTAmt,
                'GemstoneId': EditValue[0]?.GemstoneId,
                'Address': EditValue[0]?.Address,
                'City': EditValue[0]?.City,
                'State': EditValue[0]?.State,
                'PinCode': EditValue[0]?.PinCode,
                'MobileNo': EditValue[0]?.MobileNo,
                'OrderStatus': EditValue[0]?.OrderStatus,
                'PaymentStatus': EditValue[0]?.PaymentStatus,
                'TransactionID': EditValue[0]?.TransactionID,

            });
        }
    }, [EditValue, GemstoneOrderID]);

    const Reset = () => {
      
        SetValue({
            ...Value,
            'Amt': '', 'UserName': '', 'RegMobileNo': '', 'OrderNumber': '', 'CreatedTime': '',
            'UserID': '', 'GemstoneName': '', 'GSTAmt': '', 'GemstoneId': '', 'Address': '', 'City': '',
            'PinCode': '', 'MobileNo': '', 'OrderStatus': '', 'PaymentStatus': '', 'TransactionID': '',

        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "OrderNumber" || name === "GSTAmt" || name === "Amt") {
            if (!/^\d*\.?\d*$/.test(value)) {
                return;
            }
        }
        const updatedValue = { ...Value, [name]: value };
        if (name === "OrderNumber" || name === "GSTAmt") {
            const OrderNumber = parseFloat(updatedValue.OrderNumber) || 0;
            const gstAmt = parseFloat(updatedValue.GSTAmt) || 0;
            updatedValue.TotalAmt = (OrderNumber + gstAmt).toFixed(2);
        }
       

        SetValue(updatedValue);
    };
   
    return (
        <>
            <div className="row page-titles mx-0 mt-2">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active">
                            <li className="breadcrumb-item active">
                                {/* <Link to={`/PoojaList`} >PoojaList</Link> */}
                            </li>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">Home</li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">PaymentStatus</label>
                                                <span className="text-danger star-error" >*</span>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="PaymentStatus" required="required"
                                                        value={Value.PaymentStatus} placeholder=" PaymentStatus.."
                                                        onChange={handleChange}
                                                    />
                                                    <span className="validation-text"></span>
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">OrderNumber </label>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="OrderNumber" required="required"
                                                        value={Value.OrderNumber} placeholder=" OrderNumber.."
                                                        onChange={handleChange} maxLength={8}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">TransactionID</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="TransactionID" required="required" value={Value.TransactionID}
                                                        className="form-control" placeholder="TransactionID"
                                                        maxLength={16}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">GemstoneId</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="GemstoneId" required="required" value={Value.GemstoneId}
                                                        className="form-control" placeholder="GemstoneId"
                                                        maxLength={200} />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">Address</label>
                                                <span className="text-danger star-error" >*</span>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="Address" required="required"
                                                        value={Value.Address} placeholder=" Address.."
                                                        onChange={handleChange}
                                                    />
                                                    <span className="validation-text"></span>
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">PinCode </label>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="PinCode" required="required"
                                                        value={Value.PinCode} placeholder=" PinCode.."
                                                        onChange={handleChange} maxLength={8}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">City</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="City" required="required" value={Value.City}
                                                        className="form-control" placeholder="City"
                                                        maxLength={8}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">State</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="State" required="required" value={Value.State}
                                                        className="form-control" placeholder="State"
                                                        maxLength={200} />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">UserName</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="UserName" required="required" value={Value.UserName}
                                                        className="form-control" placeholder="UserName"
                                                        maxLength={8}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">UserID</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="UserID" required="required" value={Value.UserID}
                                                        className="form-control" placeholder="UserID"
                                                        maxLength={200} />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">MobileNo</label>
                                                <span className="text-danger star-error" >*</span>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="MobileNo" required="required"
                                                        value={Value.MobileNo} placeholder=" MobileNo.."
                                                        onChange={handleChange}
                                                    />
                                                    <span className="validation-text"></span>
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">OrderStatus </label>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="OrderStatus" required="required"
                                                        value={Value.OrderStatus} placeholder=" OrderStatus.."
                                                        onChange={handleChange} maxLength={8}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">Amt</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="Amt" required="required" value={Value.Amt}
                                                        className="form-control readonly" placeholder="Amt"
                                                        maxLength={8} readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">GSTAmt</label>
                                                <div className="contact-name">
                                                    <input type='text' autoComplete="off"
                                                        onChange={handleChange}
                                                        name="GSTAmt" required="required" value={Value.GSTAmt}
                                                        className="form-control readonly" placeholder="GSTAmt"
                                                        maxLength={200} readOnly />
                                                </div>
                                            </div>
                                            <div className="form-group mb-3 col-6">
                                                <label className="text-black font-w500">GemstoneName </label>
                                                <div className="contact-name">
                                                    <input type="text" className="form-control" autoComplete="off"
                                                        name="GemstoneName" required="required"
                                                        value={Value.GemstoneName} placeholder=" GemstoneName.."
                                                        onChange={handleChange} maxLength={8}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {GemstoneOrderID ? (
                                    <button className="btn btn-primary" type="submit" onClick={handleAddFormUpdate}>
                                        Update
                                    </button>
                                ) : (
                                    <button className="btn btn-primary" type="submit" onClick={handleAddFormSubmit}>
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default GemstoneUserAdd